import React from "react";
import { useNavigate } from "react-router-dom";
import sheetBlueprint from "./bulkUploadBlueprint";
import useThemeColor from "../../hooks/useThemeColor";
import useDarkMode from "../../hooks/useDarkMode";
import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel";

const BulkUploadGuide = () => {
  const themeColor = useThemeColor();
  const isDarkMode = useDarkMode();
  const navigate = useNavigate();

  const cards = sheetBlueprint.map((sheet) => (
    <div className="col-xl-4 col-lg-6 mb-4" key={sheet.name}>
      <div
        className="h-100 p-3 rounded border"
        style={{
          backgroundColor: isDarkMode ? "#2f3640" : "#f8f9fa",
          borderColor: `${themeColor}33`,
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h5 className="mb-0">{sheet.name}</h5>
          <span
            className={`badge ${
              sheet.type === "Reference" ? "bg-secondary" : "bg-success"
            }`}
          >
            {sheet.type}
          </span>
        </div>
        <p className="small mb-2">{sheet.description}</p>
        <div className="small text-muted mb-1">Key Columns</div>
        <div className="d-flex flex-wrap gap-1 mb-3">
          {sheet.keyColumns.map((col) => (
            <span
              key={col}
              className="badge bg-light text-dark border fw-normal"
            >
              {col}
            </span>
          ))}
        </div>
        {sheet.tips && (
          <>
            <div className="small text-muted mb-1">Tips</div>
            <ul className="small ps-3 mb-0">
              {sheet.tips.map((tip) => (
                <li key={tip}>{tip}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  ));

  return (
    <div className="container-fluid py-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
        <div>
          <h2 className="mb-1">Bulk Upload Guide</h2>
          <p className="text-muted mb-0">
            Step-by-step reference explaining how to prepare each sheet in the
            bulk upload workbook.
          </p>
        </div>
        <div className="d-flex gap-2 flex-wrap">
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left me-2" />
            Back
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/items/bulkUploadProducts")}
          >
            <i className="fa fa-upload me-2" />
            Go to Bulk Upload
          </button>
        </div>
      </div>

      <Panel className="mb-4">
        <PanelHeader>Workbook Structure</PanelHeader>
        <PanelBody>
          <div className="row">{cards}</div>
        </PanelBody>
      </Panel>

      <Panel>
        <PanelHeader>Recommended Workflow</PanelHeader>
        <PanelBody>
          <ol className="mb-4">
            <li>Download the latest template from the Bulk Upload screen.</li>
            <li>
              Review the reference sheets (Category_Type &amp; Category_Departments)
              to understand existing IDs and names.
            </li>
            <li>Prepare Categories, ensuring parent/child hierarchies.</li>
            <li>Create Modifier_Groups followed by Modifiers.</li>
            <li>
              Fill the Products sheet, referencing categories and modifier groups
              by name.
            </li>
            <li>
              (Optional) Add Product_Variants for any product that has multiple
              versions, making sure exactly one variant is marked as default.
            </li>
            <li>Save as .xlsx and upload via the Bulk Upload page.</li>
          </ol>
          <div className="alert alert-info mb-0">
            Need a refresher later? You can open this guide anytime from the
            Bulk Upload page using the “View Template Guide” button.
          </div>
        </PanelBody>
      </Panel>
    </div>
  );
};

export default BulkUploadGuide;

